import colors from "../../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const AssessmentResultPopoverStyle = makeStyles((theme) => ({
	dialogTitle: {
		background: colors.primary,
		color: colors.white,
	},
	tableContainer: {
		borderRadius: 8,
		boxShadow: `0 2px 8px ${colors.subtleShadowLight}`,
		maxHeight: 400,
		overflowY: "auto",
	},
	tableHead: { background: colors.whiteSmoke },
	tableHeadCell: {
		fontWeight: 700,
		color: colors.primary,
		padding: "2px",
	},
	tableRowEven: {
		backgroundColor: colors.white,
	},
	tableRowOdd: {
		backgroundColor: colors.lightSilver,
	},
	categoryTableCell: {
		fontWeight: 500,
		padding: "5px 5px 5px 10px",
	},
	resultTableCell: {
		padding: "0px 0px 0px 10px",
	},
	scoreText: { fontWeight: 600 },
	levelText: { fontWeight: 600, color: colors.black, minWidth: 40 },
	Button: {
		marginLeft: 15,
		marginRight: 15,
		color: colors.white,
		width: "100%",
		backgroundColor: colors.primary,
		textTransform: "none",
		"&:hover": {
			backgroundColor: colors.darkCrimsonRed,
		},
	},
}));

export default AssessmentResultPopoverStyle;
